/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_Select_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select Speaker" |
*
* @param {Speaker_Manager_Merge_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_select_placeholder = /** @type {((inputs?: Speaker_Manager_Merge_Select_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_Select_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner un locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите динамик")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择发言人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o alto-falante")
	return /** @type {LocalizedString} */ ("Select Speaker")
});